import type {
  ForwardRefExoticComponent,
  LazyExoticComponent,
  RefAttributes,
  SVGProps,
} from "react";

import React from "react";

export const DATA_SOURCE_ICONS: Record<
  string,
  LazyExoticComponent<
    ForwardRefExoticComponent<
      Omit<SVGProps<SVGSVGElement>, "ref"> & RefAttributes<SVGSVGElement>
    >
  >
> = {
  Atlassian: React.lazy(() => import("./atlassian.icon")),
  "Microsoft SharePoint": React.lazy(() => import("./sharepoint.icon")),
  "Microsoft Azure DevOps": React.lazy(() => import("./azure-devops.icon")),
  GitHub: React.lazy(() => import("./github.icon")),
};

export const ADMIN_DATA_SOURCE_ICONS: Record<
  string,
  LazyExoticComponent<
    ForwardRefExoticComponent<
      Omit<SVGProps<SVGSVGElement>, "ref"> & RefAttributes<SVGSVGElement>
    >
  >
> = {
  CONFLUENCE: React.lazy(() => import("./atlassian.icon")),
  SHAREPOINT: React.lazy(() => import("./sharepoint.icon")),
  ADO: React.lazy(() => import("./azure-devops.icon")),
  GITHUB: React.lazy(() => import("./github.icon")),
};
